import React, { useState } from 'react';
import { Bell } from 'lucide-react';
import { useNotifications, markAllRead, focusConversation } from '../services/notifications';

// Real notification bell: count + dropdown driven by live SignalR events
// (new inbound, assigned-to-me, escalated). Clicking an item jumps to the
// conversation; opening the dropdown clears the unread count.
const NotificationBell: React.FC = () => {
  const { items, unread } = useNotifications();
  const [open, setOpen] = useState(false);

  const toggle = () => {
    const next = !open;
    setOpen(next);
    if (next) markAllRead();
  };

  const goto = (senderId: string, threadKey?: number) => {
    setOpen(false);
    focusConversation(senderId, threadKey);
  };

  const dot = (k: string) =>
    k === 'escalated' ? 'bg-red-500' : k === 'assigned' ? 'bg-amber-500' : 'bg-brand-500';

  return (
    <div className="relative">
      <button
        onClick={toggle}
        className="relative p-2 text-gray-500 hover:text-brand-700 transition-colors"
        aria-label="Notifications"
      >
        <Bell className="w-5 h-5" />
        {unread > 0 && (
          <span className="absolute -top-1 -right-1 min-w-[1.1rem] h-[1.1rem] px-1 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
            {unread > 9 ? '9+' : unread}
          </span>
        )}
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 w-80 max-w-[90vw] bg-white rounded-lg shadow-xl border border-gray-200 z-50 max-h-96 overflow-y-auto">
            <div className="px-4 py-2 border-b border-gray-100 text-sm font-semibold text-gray-700">
              Notifications
            </div>
            {items.length === 0 ? (
              <div className="px-4 py-6 text-sm text-gray-400 text-center">Nothing new</div>
            ) : (
              items.map((n) => (
                <button
                  key={n.key}
                  onClick={() => goto(n.senderId, n.threadKey)}
                  className="w-full text-left px-4 py-2 hover:bg-gray-50 flex items-start gap-2 border-b border-gray-50 last:border-b-0"
                >
                  <span className={`mt-1 w-2 h-2 rounded-full flex-shrink-0 ${dot(n.kind)}`} />
                  <span className="text-sm text-gray-700 flex-1">{n.title}</span>
                </button>
              ))
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationBell;
